import fetch from 'isomorphic-fetch';
import HttpError from '../classes/HttpError';
import { logException } from './logger';

const expectedStatuses = [200, 201, 204, 304, 400, 401, 403, 404, 422, 429];

function parseHeaders(getHeaders, response) {
  const headers = {};
  getHeaders.forEach((header) => {
    headers[header] = response.headers.get(header);
  });
  return headers;
}

function parseResponse(getHeaders, response) {
  let headers = {};
  if (getHeaders !== undefined) {
    headers = parseHeaders(getHeaders, response);
  }
  return {
    headers,
    response: response.json(),
  };
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  return response.json().then((error) => {
    if (expectedStatuses.indexOf(response.status) === -1) {
      logException(error);
    }

    throw new HttpError(response.status, error.error);
  });
}

export default function request(url, options, getHeaders) {
  return fetch(url, options)
    .then(checkStatus)
    .then(parseResponse.bind(undefined, getHeaders))
    .then(({ response, headers }) =>
      response.then(data => ({
        response: data,
        headers,
      })),
    );
}



// WEBPACK FOOTER //
// ./src/utils/request.js